import { Component, Input } from '@angular/core';
import { ContactLensPrescriptionResponse } from '@gandalf/model/contact-lens-prescription-response';
import { ContactLensTrialResponse } from '@gandalf/model/contact-lens-trial-response';

@Component({
	selector: 'pms-contact-lens-type-hybrid',
	templateUrl: './contact-lens-type-hybrid.component.html',
})
export class ContactLensTypeHybridComponent {

	@Input()
	contactLensPrescription: ContactLensPrescriptionResponse | ContactLensTrialResponse;

	constructor() {
	}
}
